import { registerView, View, ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { useCallback } from "react";
import { Form } from "react-bootstrap";
import ContactViewModel from "viewModels/eshop/order/steps/contactViewModel";
import { StepsNavigationButtons } from "../components/stepsNavigationButtons";

const ContactView: ViewComponent<ContactViewModel> = observer(({ vm }) => {
  const tg = (value: string) => vm.localizationService.translateGeneral(`eshop.order.${value}`);
  const formRef = useCallback(node => {
    if (node !== null) {
      vm.formElement = node;
    }
  }, []);

  return (
    <>
      <div>
        <Form ref={formRef}>
          <View vm={vm.contactViewModel} />
        </Form>
      </div>
      <StepsNavigationButtons tg={tg} onBack={() => vm.onBack()} onContinue={() => vm.onContinue()} />
    </>
  );
});

registerView(ContactView, ContactViewModel);
